export default {
  comOptions:(state) => state.options.data,
}